"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _context = require("../../context");
function withHeaderApi(Component) {
  return props => /*#__PURE__*/React.createElement(_context.HeaderApiContext.Consumer, null, consumer => /*#__PURE__*/React.createElement(Component, Object.assign({
    headerApi: consumer
  }, props)));
}
var _default = exports.default = withHeaderApi;